import { render, staticRenderFns } from "./install-order.vue?vue&type=template&id=89e045a6&"
import script from "./install-order.vue?vue&type=script&lang=js&"
export * from "./install-order.vue?vue&type=script&lang=js&"
import style0 from "./install-order.vue?vue&type=style&index=0&id=89e045a6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports